import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import intl from 'react-intl-universal';
import { getUrlParam } from '../utils/index';
import styles from './About.module.scss';

function About() {
  const win: any = window;
  const year = new Date().getFullYear();
  const version = getUrlParam('version') || intl.get('about_no_version');
  return (
    <div className={styles.about}>
      <div className={styles.header}>
        {intl.get('about_text')}
        <b
          onClick={() => {
            win.electron?.ipcRenderer.closeAbout();
          }}
        >
          <CloseOutlined />
        </b>
      </div>
      <div className={styles.info}>
        <i />
        <div>YooPMS</div>
      </div>
      <p className={styles.version}>{intl.get('about_version_msg', { version })}</p>
      <div className={styles.allRights}>@{year || '2022'} wangyu.All Rights Reserved.</div>
    </div>
  );
}

export default About;
